import { ColorSchemeOption } from "@framework/types/theme"
import defaultDarkTheme from "@root/theme/nesh-dark-theme.json"
import ieeeLightTheme from "@root/theme/ieee-theme.json"
import blueOriginLightTheme from "@root/theme/blue-theme.json"
import aspenTechLightTheme from "@root/theme/aspentech-theme.json"
import flexconLightTheme from "@root/theme/flexcon-theme.json"
import DKSHLightTheme from "@root/theme/DKSH-theme.json"
import ColorconLightTheme from "@root/theme/Colorcon-theme.json"
import WRGraceLightTheme from "@root/theme/WRGrace-theme.json"
import tasiMeshurmentLightTheme from "@root/theme/tasi-theme.json"

export const allAppColorSchemeOptions: ColorSchemeOption[] = [
  defaultDarkTheme,
  ieeeLightTheme,
  aspenTechLightTheme,
  flexconLightTheme,
  blueOriginLightTheme,
  ColorconLightTheme,
  DKSHLightTheme,
  WRGraceLightTheme,
  tasiMeshurmentLightTheme,
]

export const defaultColorScheme = allAppColorSchemeOptions[0]
